module.exports = __webpack_public_path__ + "static/img/bottomQrImg.331887b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottomQrImg.jpg
// module id = 9+/K
// module chunks = 1